import { FC } from "react";
import {
  MuiBox,
  MuiCopyToClipBoard,
  MuiDoubleLabel,
  MuiGrid,
} from "../../../../../../components";
import {
  StatusBadge,
  StatusBadgeType,
} from "../../../../../../components/statusBadge/StatusBadge";
import { useGridContainer } from "../../../../../../hooks/useGridContainer";
import { useNavigationSiteCore } from "../../../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../../../hooks/useSiteCore";
import { ProgramDetail } from "../../../../modelsAndSchemas/Models";
import { programSiteCoreKeys } from "../../../../siteCore/SiteCoreKeys";
import { getValueOrBlank } from "../../../../../../helpers/utils";

interface RegistrationDetailProps {
  programDetail?: ProgramDetail;
}

export const RegistrationDetail: FC<RegistrationDetailProps> = ({
  programDetail,
}) => {
  const { fetchLabel, fetchValueByKeyOfDropdown, commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();
  const { gridSizeMedium: gridSize, gridSizeMediumClass } = useGridContainer();

  const getLabel = (key: string) => {
    return fetchLabel(programSiteCoreKeys.generalDetails, key);
  };

  return (
    <MuiBox>
      <MuiGrid
        container
        data-testid="registration-detail-tab"
        className="registration-detail-tab"
      >
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MuiDoubleLabel
            label={getLabel(programSiteCoreKeys.generalRegistrationCode)}
            value=""
          />
          <MuiCopyToClipBoard
            value={getValueOrBlank(programDetail?.registrationCode)}
            valueClass={""}
            isValueWithEllipsis
            ariaLabelCopyToClipboard={commonARIALabel.copyToClipboard}
            showCheckOnCopy
            showInlineToast
            toastText={commonLabels.copied}
          />
        </MuiGrid>
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MuiDoubleLabel
            label={getLabel(programSiteCoreKeys.generalRegistrationStatus)}
            value=""
          />
          <StatusBadge
            status={programDetail?.registrationStatus as StatusBadgeType}
            label={fetchValueByKeyOfDropdown(
              programSiteCoreKeys.generalDetails,
              programSiteCoreKeys.statusList,
              programDetail?.registrationStatus as StatusBadgeType,
            )}
          />
        </MuiGrid>
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MuiDoubleLabel
            label={getLabel(programSiteCoreKeys.generalRegistrationEmailID)}
            value={programDetail?.registrationEmailId}
            isValueWithEllipsis
            replaceEmptyWithDash
          />
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
